module.exports = __webpack_public_path__ + "static/media/usermanagement.206b9aa4.png";